import { makeStyles } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    button: {
        minWidth: px(0),
    },
});
